import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ApiService from '../../services/ApiService';
import {
  IUsersState
} from './UserModel';
import { authApiEndPoints, FAILED, PENDING, SUCCEEDED } from '../../constants/ApiEndPoints';

const initialState: IUsersState = {
  currentUser: {
    status: 'idle',
    error: ''
  }
};



export const getUserDetails = createAsyncThunk('User/GetUserDetails', async (_, thunkApi) => {
  const response = await ApiService.getData(`${authApiEndPoints.userInfoURL}`);
  return response.data;
});




export const UsersSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserDetails: (state) => {
      state.currentUser = {
        ...initialState.currentUser,
      };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getUserDetails.pending, (state) => {
        state.currentUser = {
          status: PENDING,
          error: '',
          data: undefined,
        };
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.currentUser = {
          status: FAILED,
          error: action?.error?.message || 'Something went wrong, please try again later',
          data: undefined,
        };
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.currentUser = {
          status: SUCCEEDED,
          error: '',
          data: action.payload,
        };
      });
  },
});

export const { resetUserDetails } = UsersSlice.actions;
export default UsersSlice.reducer;
